import type { ReactElement } from 'react';
import { VenueCardTemplate } from './VenueCardTemplate';
import type {
  PreviewVenue,
  HighlightCapacityType
} from '../venueCardInternalModules/types';
import { impossible } from 'common/types/impossible';
import { FeaturedVenueIcon } from 'search/components/searchResults/FeaturedVenueIcon';
import { SuperFeaturedVenueIcon } from 'search/components/searchResults/SuperFeaturedVenueIcon';

export type Props = {
  venue: PreviewVenue;
  onClickVenueLink?: () => void;
  openInNewTab?: boolean;
  highlightCapacity?: HighlightCapacityType;
  priority: 'REGULAR' | 'HIGH';
};

function featuredVenueIcon(priority: 'REGULAR' | 'HIGH'): ReactElement {
  switch (priority) {
    case 'REGULAR':
      return <FeaturedVenueIcon />;
    case 'HIGH':
      return <SuperFeaturedVenueIcon />;
    default:
      return impossible(priority);
  }
}

export function FeaturedVenueCard({
  venue,
  onClickVenueLink,
  openInNewTab = false,
  priority
}: Props): ReactElement {
  return (
    <VenueCardTemplate
      venue={venue}
      onClickVenueLink={onClickVenueLink}
      openInNewTab={openInNewTab}
      featuredVenueIcon={featuredVenueIcon(priority)}
    />
  );
}
